import { createUseStyles } from 'react-jss';
import { colors } from '../../constants/colors';
import { breakpoints } from '../../constants/breakpoints';

const styles = createUseStyles((theme) => ({
  notFoundContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'start',
    justifyContent: 'center',
    height: '100vh',
    margin: '0 100px',
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: '0 50px',
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: '0 30px',
    },
    '& h1': {
      fontSize: '60px',
      fontWeight: '600',
      lineHeight: '72px',
      color: colors.lightBlack,
      marginBottom: '24px',
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        fontSize: '40px',
        lineHeight: '48px',
      },
    },
    '& p': {
      fontSize: '20px',
      fontWeight: '400',
      lineHeight: '30px',
      color: colors.mediumGrey,
      marginBottom: '48px',
    },
  },
  error: {
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '24px',
    color: colors.darkBlue,
    marginBottom: '12px',
  },
  btnContainer: {
    display: 'flex',
    gap: '12px',
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: '100%',
      flexDirection: 'column',
      gap: '20px',
    },
  },
  backBtn: {
    padding: '0px',
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      justifyContent: 'center',
    },
  },
  backBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '16px 28px',
    '& div': {
      fontSize: '18px',
      fontWeight: '600',
      lineHeight: '28px',
      color: colors.grey,
    },
  },
  homeBtn: {
    padding: '16px 28px',
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      justifyContent: 'center',
    },
    '& div': {
      fontSize: '18px',
      fontWeight: '600',
      lineHeight: '28px',
      color: colors.white,
    },
  },
}));

export default styles;
